import { useContext, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { Grid } from "../../components/layout";
import {
  GetSomeSkrtWidget,
  StakingWidget,
} from "../../components/loyalty/widget";
import { Permission } from "../../components/permission";
import { useFetchable } from "../../store/common/fetchable";
import { isFetchableSuccess } from "../../store/common/fetchable/helpers";
import { Users } from "../../store/users/reducer";
import { BalanceTile } from "./tiles/balance";
import { CertificateTile } from "./tiles/download-certificate";
import { FraudReportsSubmittedTile } from "./tiles/fraud-reports-submitted";
import { KycKybPerformedTile } from "./tiles/kyb-kyb-performed";
import { KycStatusTile } from "./tiles/kyc-status";
import { ConnectedLoyaltyLevel } from "./tiles/loyalty-level";
import { NewKycReportTile } from "./tiles/new-kyc-report";
import { ParticipatedInTile } from "./tiles/participated-in";
import { VerificationChecksTile } from "./tiles/recent-identity-checks";
import { RecentParticipationTile } from "./tiles/recent-participations";
import { ReportAScamTile } from "./tiles/report-scam";
import { TotalCreditsTile } from "./tiles/total-credits";
import { UnverifiedWalletsTile } from "./tiles/unverified-wallets";
import { useBrowserWallet } from "../../store/wallets/crypto";
import { StakeContext } from "../staking/single/context";
import BN from "bn.js";
import { Option } from "space-monad";
import { UISref } from "@uirouter/react";
import { StyledWidget } from "../kyc-kyb-aml/components";
import { Box, Button, Link, Grid as MuiGrid } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { partition } from "lodash";
import { Wallets } from "../../store/wallets/reducer";

const StyledGrid = styled(Grid)`
  &:not(:last-child) {
    margin-bottom: 1em;
  }
`;

export const DashboardPage = () => {
  const current = useFetchable(Users.current);

  const isVerified = useMemo(
    () => isFetchableSuccess(current) && current.data.kycStatus === "VERIFIED",
    [current]
  );

  const hundredThousand = new BN('152D02C7E14AF6800000', 16);
  const zero = new BN('0', 16);
  const [flag, setFlag] = useState<boolean>(false);
  const {
    connect,
    verify,
    state,
    balance,
    accounts,
    // isVerified,
  } = useBrowserWallet();
  const { allContracts } = useContext(StakeContext);

  const allContractsResult = useMemo(
    () => allContracts.map((x) => partition(x, (y) => y.stakingAllowed)),
    [allContracts]
  );
  const currentUser = useFetchable(Users.current);
  const totalStakedbalance = useFetchable(Wallets.totalBalance);

  useEffect(() => {

    accounts.fold(
      () => (
        setFlag(false)
      ), () => (
        Option.all([balance, accounts]).fold(
          () => null,
          ([b, a]) => (
            setFlag(b.amount.gte(hundredThousand))
          )
        )
      ))

    if (isFetchableSuccess(totalStakedbalance)) {
      if (totalStakedbalance.data) {
        if (!flag) {
          setFlag(totalStakedbalance.data >= 100000)
        }
      }
    }

    if (isFetchableSuccess(currentUser)) {
      if (currentUser.data.payingSubscriber) {
        setFlag(true)
      }
    }

  }, [balance, accounts, allContractsResult, state, currentUser]);

  return (
    <>
      <Permission
        roles={["ROLE_CRYPTO"]}
        alternative={
          <>
            <StyledGrid col-lg={2} col-xs={1} col-sm={2}>
              <Grid col-xs={2}>
                <KycStatusTile />
                <KycKybPerformedTile />
                {isVerified ? <CertificateTile /> : <NewKycReportTile />}
                <ParticipatedInTile />
              </Grid>
              <Grid col-xs={2}>
                <TotalCreditsTile />
                <UnverifiedWalletsTile />
                <ReportAScamTile />
                <FraudReportsSubmittedTile />
              </Grid>
            </StyledGrid>
            <StyledGrid col-xs={1} col-sm={2}>
              <VerificationChecksTile />
              <RecentParticipationTile />
            </StyledGrid>
          </>
        }
      >
        <>
          {flag === true ? (
            <>
              <StyledGrid col-lg={1} col-xs={1} col-sm={1}>
                <StyledWidget title="">
                  Thank you for being a loyal customer
                </StyledWidget>
              </StyledGrid>
              <StyledGrid col-lg={3} col-xs={1} col-sm={2}>
                <Grid col-xs={2}>
                  <KycStatusTile />
                  {/* <KycKybPerformedTile /> */}
                  {isVerified ? <CertificateTile /> : <NewKycReportTile />}
                  {/* <ParticipatedInTile /> */}
                </Grid>
                <Grid col-xs={2}>
                  {/* <ConnectedLoyaltyLevel /> */}
                  {/* <TotalCreditsTile /> */}
                  {/* <UnverifiedWalletsTile /> */}
                  <ReportAScamTile />
                </Grid>

                {/* <Grid col-xs={2}>
            <StakingWidget />
            <GetSomeSkrtWidget />
            <FraudReportsSubmittedTile />
            <BalanceTile />
          </Grid> */}
              </StyledGrid>
            </>
          ) : (
            <>
              <StyledWidget title="You do not have enough permissions to use this portal">
                <MuiGrid container spacing={2}>
                  <MuiGrid item xs={10}>


                    The connected wallet has NO $SKRT balance or Less than $SKRT 100,000
                    <ul><li>
                      You either have no wallet connected or the connected wallet has no $SKRT balance or less than  $SKRT 100,000
                    </li>
                      <li>
                        Please update your $SKRT balance in your wallet to gain access to the dashboard functions and have your own portable reusable identity.</li>
                      <li>The public market places to obtain $SKRT can be found at:</li>
                      <ol>
                        <li>    Link 1: <Link target='_blank' href="https://app.uniswap.org/swap?inputCurrency=0x887168120cb89fb06f3e74dc4af20d67df0977f6&outputCurrency=ETH"><a>Uniswap</a></Link></li>
                        <li>    Link 2: <Link target='_blank' href="https://quickswap.exchange/#/swap?inputCurrency=0xe51e88dd08499762b8e4eb3a9f3da9b8e79608c3&outputCurrency=0x2791bca1f2de4661ed88a30c99a7a9449aa84174&swapIndex=0"><a>Quickswap</a></Link></li>
                      </ol>

                      <li>
                        <Box sx={{ marginTop: '10px' }}>
                          Alternatively,   <UISref to="^.subscription">
                            {/* <a>Subscribe</a> */}
                            <Button

                              color="primary"

                              size="small"
                              variant="contained"
                            >
                              Subscribe
                            </Button>
                          </UISref>
                        </Box></li>
                    </ul>
                  </MuiGrid>
                  <MuiGrid item xs={2}>
                    <Close color="error" style={{ fontSize: 70 }} />
                  </MuiGrid>
                </MuiGrid>
              </StyledWidget>


            </>
          )}
          {/* <StyledGrid col-xs={1} col-sm={2}>
          <VerificationChecksTile />
          <RecentParticipationTile />
        </StyledGrid> */}
        </>
      </Permission>
    </>
  );
};
